import React from 'react';
import { FlagIcon } from './FlagIcon';

export const FlagDE = props => (
    <FlagIcon {...props} viewBox="0 0 512 512">
        <rect width="512" height="170.67" y="0" fill="#000" />
        <rect width="512" height="170.67" y="170.67" fill="#D80027" />
        <rect width="512" height="170.67" y="341.33" fill="#FFDA44" />
    </FlagIcon>
);